import { getToken } from './authStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeaders = () => {
  const token = getToken();
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

const authHeadersNoContent = () => {
  const token = getToken();
  return {
    'Authorization': `Bearer ${token}`
  };
};

const handleResponse = async (res, errorMsg) => {
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(detail || errorMsg);
  }
  return res.json();
};

export const api = {
  // Auth
  login: async (email, password, remember = false) => {
    const res = await fetch(`${BACKEND_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, remember })
    });
    return handleResponse(res, 'Login fallito');
  },

  register: async (userData) => {
    const res = await fetch(`${BACKEND_URL}/api/auth/register`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(userData)
    });
    return handleResponse(res, 'Registrazione fallita');
  },

  // Leads
  getLeads: async () => {
    const res = await fetch(`${BACKEND_URL}/api/leads`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei lead');
  },

  getLead: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/leads/${id}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Lead non trovato');
  },

  createLead: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/leads`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nella creazione del lead');
  },

  updateLead: async (id, data) => {
    const res = await fetch(`${BACKEND_URL}/api/leads/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nell\'aggiornamento del lead');
  },

  deleteLead: async (id, pin) => {
    const res = await fetch(`${BACKEND_URL}/api/leads/${id}`, {
      method: 'DELETE',
      headers: { ...authHeadersNoContent(), 'X-Delete-Pin': pin || '' }
    });
    return handleResponse(res, 'Errore nell\'eliminazione del lead');
  },

  // Lead Assignment
  assignLead: async (leadId, commercialeId) => {
    const token = getToken();
    const formData = new FormData();
    formData.append('commerciale_id', commercialeId);
    const res = await fetch(`${BACKEND_URL}/api/leads/${leadId}/assign`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: formData
    });
    return handleResponse(res, 'Errore nell\'assegnazione del lead');
  },

  getMyLeads: async () => {
    const res = await fetch(`${BACKEND_URL}/api/leads/my-leads`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei lead assegnati');
  },

  // Projects
  getProjects: async () => {
    const res = await fetch(`${BACKEND_URL}/api/projects`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei progetti');
  },

  getProject: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/projects/${id}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Progetto non trovato');
  },

  createProject: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/projects`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nella creazione del progetto');
  },

  updateProject: async (id, data) => {
    const res = await fetch(`${BACKEND_URL}/api/projects/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nell\'aggiornamento del progetto');
  },

  updateProjectLavorazioni: async (id, lavorazioni) => {
    const res = await fetch(`${BACKEND_URL}/api/projects/${id}/lavorazioni`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify({ lavorazioni })
    });
    return handleResponse(res, 'Errore nell\'aggiornamento delle lavorazioni');
  },

  deleteProject: async (id, pin) => {
    const res = await fetch(`${BACKEND_URL}/api/projects/${id}`, {
      method: 'DELETE',
      headers: { ...authHeadersNoContent(), 'X-Delete-Pin': pin || '' }
    });
    return handleResponse(res, 'Errore nell\'eliminazione del progetto');
  },

  uploadProjectPhoto: async (projectId, file, tag) => {
    const token = getToken();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tag', tag);

    const res = await fetch(`${BACKEND_URL}/api/projects/${projectId}/photos`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: formData
    });
    return handleResponse(res, 'Errore nel caricamento della foto');
  },

  // Quotes / Preventivi
  calcolaQuote: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/calcola`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) });
    return handleResponse(res, 'Errore nel calcolo del preventivo');
  },

  // Piano pagamenti
  getSoluzioniPagamento: async () => {
    const res = await fetch(`${BACKEND_URL}/api/pagamenti/soluzioni`, { headers: authHeadersNoContent() });
    return handleResponse(res, 'Errore nel caricamento delle soluzioni di pagamento');
  },
  calcolaPiano: async (forma_pagamento, totale) => {
    const res = await fetch(`${BACKEND_URL}/api/pagamenti/calcola`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ forma_pagamento, totale }) });
    return handleResponse(res, 'Errore nel calcolo del piano pagamenti');
  },
  updatePianoPagamenti: async (quoteId, forma_pagamento, motivo) => {
    const res = await fetch(`${BACKEND_URL}/api/contratti/${quoteId}/piano-pagamenti`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify({ forma_pagamento, motivo }) });
    return handleResponse(res, 'Errore nel salvataggio del piano pagamenti');
  },
  getAccontiDaFatturare: async () => {
    const res = await fetch(`${BACKEND_URL}/api/pagamenti/acconti-da-fatturare`, { headers: authHeadersNoContent() });
    return handleResponse(res, 'Errore nel caricamento degli acconti da fatturare');
  },
  setVisibilitaPortale: async (quoteId, nascosto) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/visibilita-portale`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify({ nascosto }) });
    return handleResponse(res, 'Errore nell\'aggiornamento della visibilità');
  },
  fetchBlob: async (path) => {
    const res = await fetch(`${BACKEND_URL}${path}`, { headers: authHeadersNoContent() });
    if (!res.ok) throw new Error('File non disponibile');
    return res.blob();
  },

  // Calcolatore finanziario
  getProdottiFinanziari: async () => {
    const res = await fetch(`${BACKEND_URL}/api/finanziamenti/prodotti`, { headers: authHeadersNoContent() });
    return handleResponse(res, 'Errore nel caricamento dei prodotti finanziari');
  },
  saveProdottoFinanziario: async (data, id) => {
    const res = await fetch(`${BACKEND_URL}/api/finanziamenti/prodotti${id ? `/${id}` : ''}`, { method: id ? 'PUT' : 'POST', headers: authHeaders(), body: JSON.stringify(data) });
    return handleResponse(res, 'Errore nel salvataggio del prodotto finanziario');
  },
  deleteProdottoFinanziario: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/finanziamenti/prodotti/${id}`, { method: 'DELETE', headers: authHeadersNoContent() });
    return handleResponse(res, 'Errore nell\'eliminazione del prodotto finanziario');
  },
  calcolaFinanziamento: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/finanziamenti/calcola`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) });
    return handleResponse(res, 'Errore nel calcolo del finanziamento');
  },
  setVedeCostoDealer: async (userId, vede) => {
    const res = await fetch(`${BACKEND_URL}/api/users/${userId}/costo-dealer`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify({ vede_costo_dealer: vede }) });
    return handleResponse(res, 'Errore nell\'aggiornamento dell\'impostazione');
  },

  createQuote: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nella creazione del preventivo');
  },

  getLeadQuotes: async (leadId) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/lead/${leadId}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei preventivi');
  },

  getAllQuotes: async () => {
    const res = await fetch(`${BACKEND_URL}/api/quotes`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei preventivi');
  },

  getListino: async (soloAttive = false) => {
    const res = await fetch(`${BACKEND_URL}/api/listino${soloAttive ? '?solo_attive=true' : ''}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento del listino');
  },

  getQuote: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${id}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Preventivo non trovato');
  },

  updateQuote: async (id, data) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nell\'aggiornamento del preventivo');
  },

  deleteQuote: async (id, pin) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${id}`, {
      method: 'DELETE',
      headers: { ...authHeadersNoContent(), 'X-Delete-Pin': pin || '' }
    });
    return handleResponse(res, 'Errore nell\'eliminazione del preventivo');
  },

  bulkDeleteQuotes: async ({ ids = [], iso_ids = [] }, pin) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/bulk-delete`, {
      method: 'POST',
      headers: { ...authHeaders(), 'X-Delete-Pin': pin || '' },
      body: JSON.stringify({ ids, iso_ids })
    });
    return handleResponse(res, 'Errore nell\'eliminazione multipla');
  },

  changePassword: async (currentPassword, newPassword) => {
    const res = await fetch(`${BACKEND_URL}/api/auth/change-password`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ current_password: currentPassword, new_password: newPassword })
    });
    return handleResponse(res, 'Errore nel cambio password');
  },

  downloadDocument: async (docId) => {
    const res = await fetch(`${BACKEND_URL}/api/documents/download/${docId}`, {
      headers: authHeadersNoContent()
    });
    if (!res.ok) {
      const detail = await res.text().catch(() => '');
      throw new Error(detail || 'Errore nel download del documento');
    }
    const blob = await res.blob();
    const cd = res.headers.get('content-disposition') || '';
    const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return {
      data: window.URL.createObjectURL(blob),
      filename: match ? decodeURIComponent(match[1]) : 'documento',
      mime_type: blob.type
    };
  },

  deleteDocument: async (docId) => {
    const res = await fetch(`${BACKEND_URL}/api/documents/${docId}`, {
      method: 'DELETE',
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nell\'eliminazione del documento');
  },

  // Client Portal
  getClientProjects: async () => {
    const res = await fetch(`${BACKEND_URL}/api/client/projects`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei progetti');
  },

  getClientDocuments: async (projectId) => {
    const res = await fetch(`${BACKEND_URL}/api/client/documents/${projectId}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei documenti');
  },

  // Documents
  uploadDocument: async (entityType, entityId, file, descrizione = '', tag = 'altro', condivisoConCliente = false) => {
    const token = getToken();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('entity_type', entityType);
    formData.append('entity_id', entityId);
    formData.append('descrizione', descrizione);
    formData.append('tag', tag);
    formData.append('condiviso_con_cliente', condivisoConCliente);

    const res = await fetch(`${BACKEND_URL}/api/documents/upload`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: formData
    });
    return handleResponse(res, 'Errore nel caricamento del documento');
  },

  getDocuments: async (entityType, entityId) => {
    const res = await fetch(`${BACKEND_URL}/api/documents/${entityType}/${entityId}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei documenti');
  },

  // Team
  getTeam: async () => {
    const res = await fetch(`${BACKEND_URL}/api/team`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento del team');
  },

  createTeamMember: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/team`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nella creazione del membro del team');
  },

  deleteTeamMember: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/team/${id}`, {
      method: 'DELETE',
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nell\'eliminazione del membro del team');
  },

  // Invoices
  getInvoices: async () => {
    const res = await fetch(`${BACKEND_URL}/api/invoices`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento delle fatture');
  },

  createInvoice: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/invoices`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nella creazione della fattura');
  },

  updateInvoice: async (id, data) => {
    const res = await fetch(`${BACKEND_URL}/api/invoices/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore nell\'aggiornamento della fattura');
  },

  deleteInvoice: async (id, pin) => {
    const res = await fetch(`${BACKEND_URL}/api/invoices/${id}`, {
      method: 'DELETE',
      headers: { ...authHeadersNoContent(), 'X-Delete-Pin': pin || '' }
    });
    return handleResponse(res, 'Errore nell\'eliminazione della fattura');
  },

  getSollecitiImpostazioni: async () => handleResponse(await fetch(`${BACKEND_URL}/api/solleciti/impostazioni`, { headers: authHeadersNoContent() }), 'Errore caricamento impostazioni solleciti'),
  putSollecitiImpostazioni: async (body) => handleResponse(await fetch(`${BACKEND_URL}/api/solleciti/impostazioni`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(body) }), 'Errore salvataggio impostazioni solleciti'),
  getLeadFermi: async () => handleResponse(await fetch(`${BACKEND_URL}/api/solleciti/lead-fermi`, { headers: authHeadersNoContent() }), 'Errore caricamento lead fermi'),
  eseguiSollecitoLeadFermi: async () => handleResponse(await fetch(`${BACKEND_URL}/api/cron/lead-fermi/esegui-ora`, { method: 'POST', headers: authHeadersNoContent() }), 'Errore esecuzione sollecito'),
  eseguiReportLeadFermi: async () => handleResponse(await fetch(`${BACKEND_URL}/api/cron/report-lead-fermi/esegui-ora`, { method: 'POST', headers: authHeadersNoContent() }), 'Errore invio report'),

  getDaFatturare: async () => {
    const res = await fetch(`${BACKEND_URL}/api/invoices/da-fatturare`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento del riepilogo da fatturare');
  },

  uploadInvoicePdf: async (invoiceId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const token = getToken();
    const res = await fetch(`${BACKEND_URL}/api/invoices/${invoiceId}/upload-pdf`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: formData
    });
    return handleResponse(res, 'Errore nel caricamento del PDF fattura');
  },

  // Admin access log
  getVisitorAccessLog: async (from = '', to = '', email = '') => {
    const params = new URLSearchParams();
    if (from) params.set('from_date', from);
    if (to) params.set('to_date', to);
    if (email) params.set('email', email);
    return handleResponse(await fetch(`${BACKEND_URL}/api/admin/visitor-access-log?${params.toString()}`, { headers: authHeadersNoContent() }), 'Errore caricamento registro visitatore');
  },

  getAccessLog: async () => {
    const res = await fetch(`${BACKEND_URL}/api/admin/access-log`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento del log accessi');
  },

  getDocumentAccessLog: async (userEmail = '', entityType = '', dateFrom = '', dateTo = '') => {
    const params = new URLSearchParams();
    if (userEmail) params.set('user_email', userEmail);
    if (entityType) params.set('entity_type', entityType);
    if (dateFrom) params.set('date_from', dateFrom);
    if (dateTo) params.set('date_to', dateTo);
    const res = await fetch(`${BACKEND_URL}/api/admin/document-access-log?${params}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento del log documenti');
  },

  // Webhook snippets
  getWebhookSnippets: async () => {
    const res = await fetch(`${BACKEND_URL}/api/admin/webhook-snippets`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento degli snippet');
  },

  // Capo Gruppo
  getCapoGruppoGroup: async () => {
    const res = await fetch(`${BACKEND_URL}/api/capogruppo/gruppo`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento del gruppo');
  },

  getCapoGruppoStats: async (mese = '', userId = '') => {
    const params = new URLSearchParams();
    if (mese) params.set('mese', mese);
    if (userId) params.set('user_id', userId);
    const res = await fetch(`${BACKEND_URL}/api/capogruppo/stats?${params}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento delle statistiche');
  },

  // Users
  getUsers: async () => {
    const res = await fetch(`${BACKEND_URL}/api/users`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento degli utenti');
  },

  deleteUser: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/users/${id}`, {
      method: 'DELETE',
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nell\'eliminazione dell\'utente');
  },

  // Get users with Operativo/Caposquadra roles for team assignments
  getOperativi: async () => {
    const res = await fetch(`${BACKEND_URL}/api/users`, {
      headers: authHeadersNoContent()
    });
    const users = await handleResponse(res, 'Errore');
    return users.filter(u => ['Operativo', 'Caposquadra'].includes(u.ruolo));
  },

  // Contratti annullati
  getContratti: async () => {
    const res = await fetch(`${BACKEND_URL}/api/contratti`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei contratti');
  },

  getContrattiAnnullati: async () => {
    const res = await fetch(`${BACKEND_URL}/api/contratti/annullati`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei contratti annullati');
  },

  // OTP Firma Preventivo
  sendQuoteOTP: async (quoteId, email) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/otp/send`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ email })
    });
    return handleResponse(res, 'Errore invio OTP');
  },

  verifyQuoteOTP: async (quoteId, data) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/otp/verify`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore verifica OTP');
  },

  // Condominio per-committente OTP
  sendCondominioOTP: async (quoteId, committenteIndex) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/condominio/otp/send`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ committente_index: committenteIndex })
    });
    return handleResponse(res, 'Errore invio OTP committente');
  },

  // Create Cliente user account from existing lead
  createClientAccountFromLead: async (leadId) => {
    const res = await fetch(`${BACKEND_URL}/api/leads/${leadId}/create-client-account`, {
      method: 'POST',
      headers: authHeaders(),
    });
    return handleResponse(res, 'Errore creazione account Cliente');
  },
  getLeadClientAccount: async (leadId) => {
    const res = await fetch(`${BACKEND_URL}/api/leads/${leadId}/client-account`, { headers: authHeaders() });
    return handleResponse(res, 'Errore caricamento account Cliente');
  },
  resetClientAccountCredentials: async (leadId) => {
    const res = await fetch(`${BACKEND_URL}/api/leads/${leadId}/client-account/reset-credentials`, {
      method: 'POST',
      headers: authHeaders(),
    });
    return handleResponse(res, 'Errore invio nuove credenziali');
  },

  // Bulk assignment
  bulkAssignLeads: async (body) => {
    const res = await fetch(`${BACKEND_URL}/api/leads/bulk-assign`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(body)
    });
    return handleResponse(res, 'Errore assegnazione massiva lead');
  },

  bulkAssignProjects: async (body) => {
    const res = await fetch(`${BACKEND_URL}/api/projects/bulk-assign`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(body)
    });
    return handleResponse(res, 'Errore assegnazione massiva cantieri');
  },

  verifyCondominioOTP: async (quoteId, data) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/condominio/otp/verify`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore verifica OTP committente');
  },

  // Quote scadenza
  getQuoteScadenza: async (quoteId) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/scadenza`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore');
  },

  rinnovaQuote: async (quoteId) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/rinnova`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({})
    });
    return handleResponse(res, 'Errore rinnovo preventivo');
  },

  // Dashboard Stats
  getDashboardStats: async () => {
    const res = await fetch(`${BACKEND_URL}/api/stats/dashboard`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento delle statistiche');
  },

  // Notifications
  getNotifications: async (unreadOnly = false) => {
    const res = await fetch(`${BACKEND_URL}/api/notifications${unreadOnly ? '?unread_only=true' : ''}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento delle notifiche');
  },

  markNotificationRead: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/notifications/${id}/read`, {
      method: 'PUT',
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore');
  },

  // Quote PDF (HTML preview for print/download)
  getQuotePdfUrl: (quoteId) => {
    const token = getToken();
    return `${BACKEND_URL}/api/quotes/${quoteId}/pdf?token=${token}`;
  },

  getQuoteHtml: async (quoteId) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/html`, {
      headers: authHeadersNoContent()
    });
    if (!res.ok) throw new Error('Errore nel generare il preventivo');
    return res.text();
  },

  getQuotePdf: async (quoteId) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/html`, {
      headers: authHeadersNoContent()
    });
    if (!res.ok) throw new Error('Errore nel generare il PDF');
    return res.text();
  },

  // Quote foto misure
  uploadQuoteFoto: async (quoteId, file, descrizione = 'Foto misura') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('descrizione', descrizione);
    const token = getToken();
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/foto-misure`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: formData
    });
    return handleResponse(res, 'Errore upload foto');
  },

  getQuoteFotos: async (quoteId) => {
    const res = await fetch(`${BACKEND_URL}/api/quotes/${quoteId}/foto-misure`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore');
  },

  // Client portal - preventivi
  getClientPreventivi: async () => {
    const res = await fetch(`${BACKEND_URL}/api/client/preventivi`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore');
  },

  // Client portal - fatture
  getClientFatture: async () => {
    const res = await fetch(`${BACKEND_URL}/api/client/fatture`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore');
  },

  // Client portal - contratti isolamento
  getClientIsolamento: async () => {
    const res = await fetch(`${BACKEND_URL}/api/client/isolamento`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore');
  },

  // Client list for project creation (auto-fill)
  getClientsList: async () => {
    const res = await fetch(`${BACKEND_URL}/api/projects/clients-list`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore nel caricamento dei clienti');
  },

  // Calendar events
  getCalendarEvents: async (mese, anno) => {
    const params = new URLSearchParams();
    if (mese) params.append('mese', mese);
    if (anno) params.append('anno', anno);
    const res = await fetch(`${BACKEND_URL}/api/calendar/events?${params}`, {
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore');
  },

  createCalendarEvent: async (eventData) => {
    const res = await fetch(`${BACKEND_URL}/api/calendar/events`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(eventData)
    });
    return handleResponse(res, 'Errore creazione evento');
  },

  updateCalendarEvent: async (id, eventData) => {
    const res = await fetch(`${BACKEND_URL}/api/calendar/events/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(eventData)
    });
    return handleResponse(res, 'Errore aggiornamento evento');
  },

  deleteCalendarEvent: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/calendar/events/${id}`, {
      method: 'DELETE',
      headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore eliminazione evento');
  },

  exportBackup: async () => {
    const res = await fetch(`${BACKEND_URL}/api/admin/backup`, {
      headers: authHeadersNoContent()
    });
    if (!res.ok) throw new Error('Errore esportazione backup');
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
    a.href = url;
    a.download = `revolead_backup_${timestamp}.json`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  },

  // ===== Clausole contratti (solo Admin) =====
  getClausole: async () => {
    const res = await fetch(`${BACKEND_URL}/api/clausole`, { headers: authHeadersNoContent() });
    return handleResponse(res, 'Errore caricamento clausole');
  },
  updateClausole: async (categoria, data) => {
    const res = await fetch(`${BACKEND_URL}/api/clausole/${categoria}`, {
      method: 'PUT', headers: authHeaders(), body: JSON.stringify(data)
    });
    return handleResponse(res, 'Errore salvataggio clausole');
  },
  resetClausole: async (categoria) => {
    const res = await fetch(`${BACKEND_URL}/api/clausole/${categoria}/reset`, {
      method: 'POST', headers: authHeadersNoContent()
    });
    return handleResponse(res, 'Errore ripristino clausole');
  }
};
